import type { ModalButton, DynamicComponent, Flyout } from '@i22team/td-longtail-vue-components';

export type FlyoutOpenProps = {
  heading?: string | null;
  ariaLabel?: string | null;
  content?: string | null;
  component?: DynamicComponent | null;
  closeOnBackdrop?: boolean;
  buttons?: ModalButton[] | null;
  success?: boolean;
  error?: boolean;
  warning?: boolean;
};

export type FlyoutPlugin = {
  open: (props: FlyoutOpenProps) => void;
  close: () => void;
  info: (message: string, options: any) => void;
  el: InstanceType<any>;
};

export const flyoutState = reactive<FlyoutOpenProps>({
  heading: null,
  content: null,
  ariaLabel: null,
  component: null,
  buttons: [],
  closeOnBackdrop: false,
  success: false,
  error: false,
  warning: false,
});

export const flyout = ref<typeof Flyout | undefined>(undefined);

export const resetFlyout = () => {
  flyoutState.heading = null;
  flyoutState.ariaLabel = null;
  flyoutState.content = null;
  flyoutState.component = null;
  flyoutState.buttons = [];
  flyoutState.closeOnBackdrop = true;
  flyoutState.success = false;
  flyoutState.error = false;
  flyoutState.warning = false;
};

export const openFlyout = (props: FlyoutOpenProps) => {
  resetFlyout();
  Object.keys(props).forEach((key) => {
    // @ts-ignore
    flyoutState[key] = props[key];
  });
  flyout.value?.openDialog();
};

export const closeFlyout = () => {
  flyout.value?.closeDialog();
  resetFlyout();
};

const getAriaLabel = (type: string | undefined) => {
  if (type === 'error') return 'Fehlermeldung';
  if (type === 'success') return 'Erfolgsmeldung';
  if (type === 'warning') return 'Warnmeldung';
  return undefined;
};

// Compatibility to dialog.info.
export const infoFlyout = (message: string, options: any = {}) => {
  openFlyout({
    content: message,
    ariaLabel: options.ariaLabel || getAriaLabel(options.type),
    success: options.type === 'success',
    error: options.type === 'error',
    warning: options.type === 'warning',
    buttons: [
      {
        autofocus: true,
        name: options.buttonText || 'OK',
        outline: true,
        isWide: true,
      },
    ],
  });
};
